import { ofArray } from "./fable_modules/fable-library.3.7.20/List.js";
import { fromParts } from "./fable_modules/fable-library.3.7.20/Decimal.js";
import { printf, toText } from "./fable_modules/fable-library.3.7.20/String.js";

export function monthsInAdvance(getTranslation) {
    const months = getTranslation("Common.Months");
    return ofArray([["0", getTranslation("Containers.FeesTable.FeeForm.MonthsInAdvanceInArrears")], ["1", "1 " + getTranslation("Common.Month")], ["2", "2 " + months], ["3", "3 " + months], ["4", "4 " + months], ["5", "5 " + months], ["6", "6 " + months], ["7", "7 " + months], ["8", "8 " + months], ["9", "9 " + months], ["10", "10 " + months], ["11", "11 " + months], ["12", "12 " + months], ["13", "13 " + months]]);
}

export function cancellationPeriodMonths(getTranslation) {
    const months = getTranslation("Common.Months");
    return ofArray([["0", getTranslation("Common.None")], ["1", "1 " + getTranslation("Common.Month")], ["2", "2 " + months], ["3", "3 " + months], ["4", "4 " + months], ["5", "5 " + months], ["6", "6 " + months], ["12", "12 " + months]]);
}

export function getVatRates(countryCode) {
    const matchValue = countryCode.ThreeLetter;
    switch (matchValue) {
        case "SWE": {
            return ofArray([fromParts(25, 0, 0, false, 0), fromParts(12, 0, 0, false, 0), fromParts(6, 0, 0, false, 0), fromParts(0, 0, 0, false, 0)]);
        }
        case "FIN": {
            return ofArray([fromParts(255, 0, 0, false, 1), fromParts(24, 0, 0, false, 0), fromParts(14, 0, 0, false, 0), fromParts(135, 0, 0, false, 1), fromParts(0, 0, 0, false, 0)]);
        }
        case "NOR": {
            return ofArray([fromParts(25, 0, 0, false, 0), fromParts(15, 0, 0, false, 0), fromParts(12, 0, 0, false, 0), fromParts(0, 0, 0, false, 0)]);
        }
        case "DNK": {
            return ofArray([fromParts(25, 0, 0, false, 0), fromParts(0, 0, 0, false, 0)]);
        }
        default: {
            throw (new Error(toText(printf("[getVatRates] Could not parse countryCode \u0027%s\u0027."))(countryCode.ThreeLetter)));
        }
    }
}

export function afterSomeTimeSelects(getTranslation) {
    const months = getTranslation("Common.Months");
    return ofArray([["1", "1 " + getTranslation("Common.Month")], ["2", "2 " + months], ["3", "3 " + months], ["4", "4 " + months], ["5", "5 " + months], ["6", "6 " + months], ["7", "7 " + months], ["8", "8 " + months], ["9", "9 " + months], ["10", "10 " + months], ["11", "11 " + months], ["12", "12 " + months], ["24", "24 " + months], ["36", "36 " + months], ["48", "48 " + months], ["60", "60 " + months]]);
}

